// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function FiningAgents({ product, ...rest }) {
  if (!hasContent(product)) return null;
  return (
    <Section title={<Trans>Fining Agents</Trans>} {...rest}>
      <Text>{product.finingAgents?.filter(Boolean).join(', ')}</Text>
    </Section>
  );
}

FiningAgents.hasContent = hasContent;

function hasContent(product) {
  return Boolean(product?.finingAgents?.length);
}

export const fragment = graphql`
  fragment FiningAgents on Bottlebooks_Product {
    finingAgents
  }
`;

FiningAgents.fragment = gql`
  fragment FiningAgents on Product {
    finingAgents
  }
`;
